/*
 * @Author: your name
 * @Date: 2021-06-07 20:40:40
 * @LastEditTime: 2021-07-09 14:11:34
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /burgeon-project-logic/service/modules/systemConfig.js
 */
// 系统配置
import qs from 'qs'

export default {
  getChannelProductById: params => $network.post('/api/cs/sg/channel/getChannelProductById', params),
  manualMatchingApi: params => $network.post('/api/cs/sg/channel/manualMatching', params),
  batchUpdateSync: params => $network.post('/api/cs/sg/channel/batchUpdateSync', params),
  syncColPermission: params => $network.get(`/api/cs/md/syncColPermission?${qs.stringify(params)}`),

  mqEnableAll: params => $network.post('/api/cs/md/v1/mqEnableAll', params),
  batchUpdateMqEnv: params => $network.post('/api/cs/md/v1/batchUpdateMqEnv', params),
  /**
   *  查看用户权限
   * /api/cs/md/chrstoregroupquery  店仓权限
   * /p/cs/chrsuppgroupquer  供应商权限
   * /api/cs/md/chrgroupsdistrib/query  配销中心
   * /p/cs/cgroupsbrand/query  品牌权限
   * /p/cs/cgrouppro/query  商品权限
   * /p/cs/chrgroupscompany/query  公司权限
   * /api/cs/md/cusergroupquery  角色权限
   * */


   getMenuTree: params => $network.post('/api/cs/md/getMenuTree', params.params).then(res => {
    if (typeof params.success === 'function') {
      params.success(res);
    }
  }),

   cgroupsquery: params => $network.post('/api/cs/md/cgroupsquery', params.params).then(res => {
    if (typeof params.success === 'function') {
      params.success(res);
    }
  }),

   savePermission: params => $network.post('/api/cs/md/savePermission', params.params).then(res => {
    if (typeof params.success === 'function') {
      params.success(res);
    }
  }),

   copyPermission: params => $network.post('/api/cs/md/copyPermission', params.params).then(res => {
    if (typeof params.success === 'function') {
      params.success(res);
    }
  }),

   queryMenuPermission: params => $network.post('/api/cs/md/queryMenuPermission', params.params).then(res => {
    if (typeof params.success === 'function') {
      params.success(res);
    }
  }),

  fetchActionsInCustomizePage: params => $network.post('/api/cs/md/fetchActionsInCustomizePage', params.params).then(res => {
    if (typeof params.success === 'function') {
      params.success(res);
    }
  }),

  groupTreeload: params => $network.post('/api/cs/md/groupTreeload', params).then(res=>{
    if (typeof params.success === 'function') {
      params.success(res);
    }
  }),

  chrstoregroupquery: (url, params) => $network.post(url, params),
  // 请求tab列表页
  userstreeload: params => $network.post('/api/cs/md/userstreeload', params),
  // /api/cs/md/usertreequery
  usertreequery: params => $network.post('/api/cs/md/usertreequery', params),
  /**
   * 角色
   */
  // 权限查询接口'
  selectPermissionColumn: params => $network.post('/p/cs/permission/v1/selectDataPermission', params),
  /**
   * 用户档案
   * */

  getPictureTypeList: params => $network.get(`/api/cs/md/getPictureTypeList?${qs.stringify(params)}`),
  savePictureInfo: params => $network.post('/api/cs/md/savePictureInfo', params),
  getPictureList: params => $network.get(`/api/cs/md/getPictureList?${qs.stringify(params)}`),
  // 获取表格 /api/cs/md/cgroupcolumnquery
  selectDataPermission: (url, params) => $network.post(url, params),
  // 保存 /p/cs/objectSave /p/cs/permission/v1/saveDataPermission
  objectSave: (url, params) => $network.post(url, params),
  // 复制权限 /api/cs/md/copyShopPermission
  copyShopPermission: params => $network.post('/api/cs/md/copyShopPermission', params),
  handleException: params => $network.post('/p/cs/handleException', params),

  permGroupDetail: params => $network.post('/api/cs/md/permission/data/permGroup/detail', params),
  permGroupSave: params => $network.post('/api/cs/md/permission/data/permGroup/save', params),
  permGroupUserQuery: params => $network.post('/api/cs/md/permission/data/permGroup/user/query', params),
  permGroupRelationSave: params => $network.post('/api/cs/md/permission/data/permGroup/relation/save', params),
  permGroupRelationDelete: params => $network.post(`/api/cs/md/permission/data/permGroup/relation/delete?${qs.stringify(params)}`),
  getActiveBillType: params => $network.post('/api/cs/work/getActiveBillType', params),
  getMiddleSystemData: params => $network.post('/api/cs/work/getMiddleSystemData', params), // 中台数据
  getOuterSystemData: params => $network.post('/api/cs/work/getOuterSystemData', params), // 对外数据
  saveMonitorPageConfig: params => $network.post('/api/cs/work/saveMonitorPageConfig', params), // 保存任务配置
};
